// Fa 계산 함수 등 유틸리티 함수들

export const interpolateFa = (S, S1, S2, Fa1, Fa2) => {
  return Fa1 + ((S - S1) / (S2 - S1)) * (Fa2 - Fa1);
};

// 다른 유틸리티 함수들도 이곳에 작성

  // Fa 계산 함수
export const calculateFa = (soilType, S) => {
  if (soilType === 'S2') {
    if (S <= 0.1) return 1.4;
    if (S === 0.2) return 1.4;
    if (S === 0.3) return 1.3;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 1.4, 1.4);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 1.4, 1.3);
  }

  if (soilType === 'S3') {
    if (S <= 0.1) return 1.7;
    if (S === 0.2) return 1.5;
    if (S === 0.3) return 1.3;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 1.7, 1.5);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 1.5, 1.3);
  }

  if (soilType === 'S4') {
    if (S <= 0.1) return 1.6;
    if (S === 0.2) return 1.4;
    if (S === 0.3) return 1.2;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 1.6, 1.4);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 1.4, 1.2);
  }

  if (soilType === 'S5') {
    if (S <= 0.1) return 1.8;
    if (S === 0.2) return 1.3;
    if (S === 0.3) return 1.3;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 1.8, 1.3);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 1.3, 1.3);
  }

  return null; // 해당하는 조건이 없을 경우
};

export const calculateFv = (soilType, S) => {
  if (soilType === 'S2') {
    if (S <= 0.1) return 1.5;
    if (S === 0.2) return 1.4;
    if (S === 0.3) return 1.3;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 1.5, 1.4);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 1.4, 1.3);
  }

  if (soilType === 'S3') {
    if (S <= 0.1) return 1.7;
    if (S === 0.2) return 1.6;
    if (S === 0.3) return 1.5;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 1.7, 1.6);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 1.6, 1.5);
  }

  if (soilType === 'S4') {
    if (S <= 0.1) return 2.2;
    if (S === 0.2) return 2.0;
    if (S === 0.3) return 1.8;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 2.2, 2.0);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 2.0, 1.8);
  }

  if (soilType === 'S5') {
    if (S <= 0.1) return 3.0;
    if (S === 0.2) return 2.7;
    if (S === 0.3) return 2.4;
    // 선형 보간법 적용
    if (S > 0.1 && S < 0.2) return interpolateFa(S, 0.1, 0.2, 3.0, 2.7);
    if (S > 0.2 && S < 0.3) return interpolateFa(S, 0.2, 0.3, 2.7, 2.4);
  }

  return null; // 해당하는 조건이 없을 경우
};


// 유효 지반 가속도 계산 함수
export const S = (regionType, recurrenceInterval) => {
  
  // Z 값 결정
  const Z = regionType == 2 ? 0.07 : 0.11;

  // I 값 결정
  const I = {
    500: 1,
    1000: 1.4,
    2400: 2.0,
    4800: 2.6,
  }[recurrenceInterval] || 0; // 잘못된 값일 경우 0 반환

  // 유효 지반 가속도 = Z * I
  return Z * I;
};